import { render } from "./IconArrowDownload.vue?vue&type=template&id=3b2f46fa"
import script from "./IconArrowDownload.vue?vue&type=script&lang=js"
export * from "./IconArrowDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconArrowDownload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b2f46fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b2f46fa', __exports__)) {
    api.reload('3b2f46fa', __exports__)
  }
  
  module.hot.accept("./IconArrowDownload.vue?vue&type=template&id=3b2f46fa", () => {
    api.rerender('3b2f46fa', render)
  })

}


export default __exports__